<template>
    <Toast />
    <Spinner v-if="isLoading" />
    <div class="grid nested-grid">
        <div class="col-12">
            <div class="card fluid cardheader">
                <div class="col-12">
                    <h5 class="stationsHeader">{{ translated('refillOverviewTitle').toUpperCase() }}</h5>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="card fluid">
                <div class="field grid">
                    <label class="col-12 md:col-3 mb-md-0">{{ translated('financiranjerefillpointlabel') }}</label>
                    <div class="col-12 md:col-9">
                        <Dropdown v-model="form.financedid" :options="financedOptions" optionLabel="label" optionValue="value" :placeholder="translated('documentGenerationFinancedAll')" :showClear="true" />
                    </div>
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-3 mb-md-0">{{ translated('documentGenerationFilterCpoName') }}</label>
                    <div class="col-12 md:col-9">
                        <InputText type="text" v-model="form.cponame" />
                    </div>
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-3 mb-md-0">{{ translated('documentGenerationFilterEvseId') }}</label>
                    <div class="col-12 md:col-9">
                        <InputText type="text" v-model="form.evseid" />
                    </div>
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-3 mb-md-0">{{ translated('documentGenerationFilterUpravicenec') }}</label>
                    <div class="col-12 md:col-9">
                        <InputText type="text" v-model="form.upravicenec" />
                    </div>
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-3 mb-md-0">{{ translated('refillOverviewFilterAddress') }}</label>
                    <div class="col-12 md:col-9">
                        <InputText type="text" v-model="form.address" />
                    </div>
                </div>

                <div class="field grid">
                    <label class="col-12 md:col-3 mb-md-0">{{ translated('refillOverviewFilterCity') }}</label>
                    <div class="col-12 md:col-9">
                        <InputText type="text" v-model="form.city" />
                    </div>
                </div>

                <div class="page-actions">
                    <Button :label="translated('refillOverviewSearch')" icon="pi pi-search" class="p-button-secondary" @click="loadRefillPoints" />
                </div>
            </div>
        </div>

        <div class="col-12" v-if="searched">
            <div class="card fluid">
                <DataTable :key="searchCount" :value="rows" class="p-datatable-sm" removableSort :resizableColumns="true" showGridlines dataKey="RefillPointId"
                v-model:filters="filters1" :loading="isLoading" responsiveLayout="scroll" :rowHover="true"
                :globalFilterFields="['EvseId','SiteName','CompanyName','SiteStreet','SiteCity','FinancedName','ReceivingSupportCompanyName','ReceivingAgreementName']"
                :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10,30,50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <template #header>
                        <div class="flex p-jc-end">
                            <span class="p-input-icon-right ">
                                <i class="pi pi-search" />
                                <InputText v-model="filters1['global'].value" :placeholder="translated('keywordsearch')" />
                            </span>
                        </div>
                    </template>
                    <template #empty>
                        No refill points found.
                    </template>

                    <Column headerStyle="width: 3em" bodyStyle="text-align: center">
                        <template #body="slotProps">
                            <router-link :to="{ name: 'EditEnergySite', params: { id: slotProps.data.SiteId, viewedCompanName: slotProps.data.CompanyName, viewcompanyid: slotProps.data.CompanyId }}">
                                <Button icon="pi pi-eye" class="p-button-raised p-button-rounded p-button-secondary" />
                            </router-link>
                        </template>
                    </Column>
                    <Column field="EvseId" :header="translated('documentGenerationFilterEvseId')" :sortable="true"></Column>
                    <Column field="SiteName" :header="translated('energysite')" :sortable="true"></Column>
                    <Column field="CompanyName" :header="translated('refillOverviewOwner')" :sortable="true"></Column>
                    <Column :header="translated('documentGenerationAddress')">
                        <template #body="{data}">
                            {{ (data.SiteStreet ?? '') + ' ' + (data.SiteHouseNumber ?? '') }}
                        </template>
                    </Column>
                    <Column :header="translated('zipcity')">
                        <template #body="{data}">
                            {{ (data.SiteZip ?? '') + ' ' + (data.SiteCity ?? '') }}
                        </template>
                    </Column>
                    <Column field="ChargingPower" :header="translated('refillOverviewPower')" :sortable="true" bodyClass="p-text-right">
                        <template #body="{data}">
                            {{ data.ChargingPower == null ? '' : data.ChargingPower }}
                        </template>
                    </Column>
                    <Column field="FinancedName" :header="translated('documentGenerationFilterFinanced')"></Column>
                    <Column field="ReceivingSupportCompanyName" :header="translated('documentGenerationReceiving')"></Column>
                    <Column field="ReceivingAgreementName" :header="translated('refillOverviewAgreement')"></Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import createHttp from "@/services/http";
import { computed } from "vue";
import Spinner from "@/components/Spinner.vue";
import store from "@/store";

// Pregled polnilnih mest: iskanje polnilnih mest po filtrih in prikaz rezultatov.
export default {
    name: 'RefillPointsOverview',
    components: { Spinner },
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            isLoading: false,
            searched: false,
            searchCount: 0,
            rows: [],
            financedOptions: [],
            filters1: null,
            form: {
                financedid: null,
                cponame: '',
                evseid: '',
                upravicenec: '',
                address: '',
                city: ''
            }
        };
    },
    created() {
        this.initFilters1();
    },
    async mounted() {
        await this.loadInitialData();
    },
    methods: {
        initFilters1() {
            this.filters1 = {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            }
        },
        async loadInitialData() {
            this.isLoading = true;
            try {
                const http = createHttp(true);
                const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetFinanceRecords");
                this.setFinancedOptions(result.data || []);
            }
            finally {
                this.isLoading = false;
            }
        },
        setFinancedOptions(records) {
            this.financedOptions = (records || []).map(item => ({
                label: item.Name,
                value: item.Id
            }));
        },
        buildSearchParams() {
            return {
                cponame: this.form.cponame ?? '',
                evseid: this.form.evseid ?? '',
                upravicenec: this.form.upravicenec ?? '',
                address: this.form.address ?? '',
                city: this.form.city ?? '',
                financedid: this.form.financedid
            };
        },
        async loadRefillPoints() {
            this.isLoading = true;
            try {
                const http = createHttp(true);
                const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetAllRefillPointsByFilter", {
                    params: this.buildSearchParams()
                });

                this.rows = result.data || [];
                this.searched = true;
                this.searchCount++;
                this.initFilters1();
            }
            catch (error) {
                if (error?.response?.status === 404) {
                    this.rows = [];
                    this.searched = true;
                    this.searchCount++;
                    this.initFilters1();
                }
                else {
                    const detail = error?.response?.data?.message || this.translated('refillOverviewSearchError');
                    this.$toast.add({ severity: 'error', summary: 'Error', detail, life: 5000 });
                }
            }
            finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.page-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1.5rem;
    flex-wrap: wrap;
}
</style>
